var current_breakpoint = false;

function check_breakpoint() {
    const windowWidth = window.innerWidth;
    const breakpoints = [
        {
            name: 'sm',
            size: 600
        },
        {
            name: 'md',
            size: 782
        },
        {
            name: 'lg',
            size: 992
        },
        {
            name: 'xl',
            size: 1200
        },
        {
            name: '2xl',
            size: 1440
        },
    ];
    let name = 'xs';
    breakpoints.forEach(breakpoint => {
        if (windowWidth >= breakpoint.size) {
            name = breakpoint.name;
        }
    });
    if (current_breakpoint != name) {
        current_breakpoint = name;
        const breakpoint_event = new CustomEvent('breakpoint', {
            bubbles: true,
            detail: { breakpoint: current_breakpoint }
        });
        window.dispatchEvent(breakpoint_event);
    }
}

setTimeout(() => {
    check_breakpoint();
});

window.addEventListener('resize', check_breakpoint);